"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const entity_1 = require("../../type/entity");
const getContentType_1 = require("../getContentType");
const getAvailableOn_1 = require("./getAvailableOn");
const getDueDate_1 = require("./getDueDate");
const getUnitSetting_1 = tslib_1.__importDefault(require("./getUnitSetting"));
function getUnitAssignInfo(command, unitId) {
    const offerUnitSetting = getUnitSetting_1.default(command, unitId);
    if (!offerUnitSetting) {
        return undefined;
    }
    return offerUnitSetting.dueDateDetails;
}
function getDueDateFromDueDateDetail(command, dueDateDetail) {
    if (!dueDateDetail) {
        return '-1';
    }
    const { timeStamp } = command;
    const dueDate = getDueDate_1.getDueDateFromType(command, dueDateDetail, timeStamp);
    return dueDate;
}
function parentDueDate(command) {
    const parentDueDateDetail = getUnitAssignInfo(command, command.rootContentId);
    return getDueDateFromDueDateDetail(command, parentDueDateDetail);
}
function getDueDate(command, content) {
    const dueDateDetail = getUnitAssignInfo(command, content._id);
    if (!dueDateDetail) {
        return parentDueDate(command);
    }
    return getDueDateFromDueDateDetail(command, dueDateDetail);
}
function getAssignAction(command, content) {
    if (command.rootContentId !== content._id) {
        return entity_1.AssignAction.CURRICULUM;
    }
    else {
        const contentType = getContentType_1.getContentType(content);
        switch (contentType) {
            case entity_1.ContentType.COURSE:
                return entity_1.AssignAction.COURSE;
            case entity_1.ContentType.CURRICULUM:
                return entity_1.AssignAction.CURRICULUM;
            case entity_1.ContentType.ILT:
                return entity_1.AssignAction.ILT;
            case entity_1.ContentType.CHECKPOINT:
                return entity_1.AssignAction.CHECKPOINT;
            default:
                throw new Error('Invalid type ' + contentType);
        }
    }
}
function updateEnrolmentInfoBasedOnContent(command, content, enrolmentInfoObject) {
    const contentType = getContentType_1.getContentType(content);
    switch (contentType) {
        case entity_1.ContentType.ILT:
            const currentUnitSetting = (command.unitSettings || []).find(unitSetting => unitSetting.unitId === content._id);
            if (currentUnitSetting) {
                enrolmentInfoObject.sessionIds = currentUnitSetting.sessionIds;
                enrolmentInfoObject.learnerType = currentUnitSetting.learnerType;
            }
            break;
        default:
            break;
    }
}
function updateEnrolmentInfoFromDueDateType(command, contentId, enrolmentInfoObject) {
    const dueDateDetails = getUnitAssignInfo(command, contentId);
    if (dueDateDetails && dueDateDetails.type === entity_1.DueDateType.CONTENT_DEPENDENT) {
        enrolmentInfoObject.dueInDays = dueDateDetails.dueInDays;
        enrolmentInfoObject.dependentOnContentId = dueDateDetails.dependentOnContentId;
    }
}
function getUnitAvailableOnSettings(command, unitId) {
    const offerUnitSetting = getUnitSetting_1.default(command, unitId);
    if (!offerUnitSetting) {
        return undefined;
    }
    return offerUnitSetting.availableOnDetails;
}
function getAvailableOn(command, content) {
    const unitAvailableOnSettings = getUnitAvailableOnSettings(command, content._id);
    if (!unitAvailableOnSettings) {
        return undefined;
    }
    const availableOn = getAvailableOn_1.getAvailableOnFromType(command, unitAvailableOnSettings);
    return availableOn;
}
function getEnrolmentAssignInfo(command, content) {
    const { assignmentEventId, timeStamp, assignerId, assignType, prerequisiteOf } = command;
    const dueDate = getDueDate(command, content);
    const assignAction = getAssignAction(command, content);
    const availableOn = getAvailableOn(command, content);
    const enrolmentInfoObject = {
        assignDate: timeStamp,
        assignerId,
        assignmentEventId,
        assignType,
        dueDate,
        assignAction,
        availableOn,
        prerequisiteOf
    };
    const contentId = content._id.toString();
    updateEnrolmentInfoBasedOnContent(command, content, enrolmentInfoObject);
    updateEnrolmentInfoFromDueDateType(command, contentId, enrolmentInfoObject);
    return enrolmentInfoObject;
}
exports.default = getEnrolmentAssignInfo;
//# sourceMappingURL=getEnrolmentAssignInfo.js.map